exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-about-tsx": () => import("./../../../src/pages/about.tsx" /* webpackChunkName: "component---src-pages-about-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-petitenget-tsx": () => import("./../../../src/pages/petitenget.tsx" /* webpackChunkName: "component---src-pages-petitenget-tsx" */),
  "component---src-pages-try-tsx": () => import("./../../../src/pages/try.tsx" /* webpackChunkName: "component---src-pages-try-tsx" */)
}

